<script>
  import  Router from 'svelte-spa-router';
  import routes from './routes.js';
</script>

<Router {routes} useHash={false} />